import { WinningCard } from "../lib/localStorage";

export const CARDS : WinningCard[] = 
[
  {
    "id": 1,
    "albumid": 1,
    "image": "https://ibighit.com/bts/images/bts/discography/butter-2/concept_version-4/bY5hzqe7z0M3_m.jpg"
  },
  {
    "id": 2,
    "albumid": 1,
    "image": "https://ibighit.com/bts/images/bts/discography/butter-2/concept_version-4/gNk3TCvEVS0U_m.jpg"
  },
  {
    "id": 3,
    "albumid": 1,
    "image": "https://ibighit.com/bts/images/bts/discography/butter-2/concept_version-4/aZ2tML3CwSaa_m.jpg"
  },
  {
    "id": 4,
    "albumid": 1,
    "image": "https://ibighit.com/bts/images/bts/discography/butter-2/concept_version-4/ta91uSjDPyS8_m.jpg"
  },
  {
    "id": 5,
    "albumid": 1,
    "image": "https://ibighit.com/bts/images/bts/discography/butter-2/concept_version-4/gVh50xxbmvu5_m.jpg"
  },
  {
    "id": 6,
    "albumid": 1,
    "image": "https://ibighit.com/bts/images/bts/discography/butter-2/concept_version-4/xhpifnjmavs0_m.jpg"
  },
  {
    "id": 7,
    "albumid": 1,
    "image": "https://ibighit.com/bts/images/bts/discography/butter-2/concept_version-4/k5KMOgzoGXCv_m.jpg"
  },
  {
    "id": 8,
    "albumid": 2,
    "image": "https://ibighit.com/bts/images/bts/discography/butter/teaser-01/SoKlBL7UjZzbvjz-m.jpg"
  },
  {
    "id": 9,
    "albumid": 2,
    "image": "https://ibighit.com/bts/images/bts/discography/butter/teaser-01/rj0fLSW1xL1tp9f-m.jpg"
  },
  {
    "id": 10,
    "albumid": 2,
    "image": "https://ibighit.com/bts/images/bts/discography/butter/teaser-01/EArAxbR6Z4yMeqd-m.jpg"
  },
  {
    "id": 11,
    "albumid": 2,
    "image": "https://ibighit.com/bts/images/bts/discography/butter/teaser-01/QgvM1GexCfBro57-m.jpg"
  },
  {
    "id": 12,
    "albumid": 2,
    "image": "https://ibighit.com/bts/images/bts/discography/butter/teaser-01/HU3fwnBFadX0J0M-m.jpg"
  },
  {
    "id": 13,
    "albumid": 2,
    "image": "https://ibighit.com/bts/images/bts/discography/butter/teaser-01/Il6Auy3WZbU3btG-m.jpg"
  },
  {
    "id": 14,
    "albumid": 2,
    "image": "https://ibighit.com/bts/images/bts/discography/butter/teaser-01/MKVHv9DgAX4UzNe-m.jpg"
  },
  {
    "id": 15,
    "albumid": 3,
    "image": "https://ibighit.com/bts/images/bts/discography/be/28xJhIpasK3Mo6oQjsj1NKEM-m.jpg"
  },
  {
    "id": 16,
    "albumid": 3,
    "image": "https://ibighit.com/bts/images/bts/discography/be/cMNMVm7OQ0rnDddcljAqpYzq-m.jpg"
  },
  {
    "id": 17,
    "albumid": 3,
    "image": "https://ibighit.com/bts/images/bts/discography/be/rntwzPQaS4NAU4hID4Ietvsp-m.jpg"
  },
  {
    "id": 18,
    "albumid": 3,
    "image": "https://ibighit.com/bts/images/bts/discography/be/CpWGwfV7ONKvbx0ecQ52rYay-m.jpg"
  },
  {
    "id": 19,
    "albumid": 3,
    "image": "https://ibighit.com/bts/images/bts/discography/be/QcgA1pHY1oVJdCJC6G1gUnWo-m.jpg"
  },
  {
    "id": 20,
    "albumid": 3,
    "image": "https://ibighit.com/bts/images/bts/discography/be/Ei0vgMTqRBKo97InMQNRbOXH-m.jpg"
  },
  {
    "id": 21,
    "albumid": 3,
    "image": "https://ibighit.com/bts/images/bts/discography/be/M4tHeuV91fjvOOpLAKuu4qyk-m.jpg"
  },
  {
    "id": 22,
    "albumid": 4,
    "image": "https://ibighit.com/bts/images/bts/discography/dynamite/tKPiBftDVZxNmXFLqgykp9Sk-m.jpg"
  },
  {
    "id": 23,
    "albumid": 4,
    "image": "https://ibighit.com/bts/images/bts/discography/dynamite/4qEoQbLB4DKdVoms8nAotKn5-m.jpg"
  },
  {
    "id": 24,
    "albumid": 4,
    "image": "https://ibighit.com/bts/images/bts/discography/dynamite/eFupxLF4IQMBuodtS4YqWMx6-m.jpg"
  },
  {
    "id": 25,
    "albumid": 4,
    "image": "https://ibighit.com/bts/images/bts/discography/dynamite/ZPmNP49sWARVDfpYubmDxfry-m.jpg"
  },
  {
    "id": 26,
    "albumid": 4,
    "image": "https://ibighit.com/bts/images/bts/discography/dynamite/yxFooutic8ocblB4HKtQXtnL-m.jpg"
  },
  {
    "id": 27,
    "albumid": 4,
    "image": "https://ibighit.com/bts/images/bts/discography/dynamite/7PKOf7Yi5MBs5D7DD3qDz7lA-m.jpg"
  },
  {
    "id": 28,
    "albumid": 4,
    "image": "https://ibighit.com/bts/images/bts/discography/dynamite/gDnM0f8B2AORLVa6jFaCjnk6-m.jpg"
  },
  {
    "id": 29,
    "albumid": 5,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/JIEQQePII2jby8wRxZxEsNJ2-m.jpg"
  },
  {
    "id": 30,
    "albumid": 5,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/VK41IekAQM35UCsKCNN7Jg5a-m.jpg"
  },
  {
    "id": 31,
    "albumid": 5,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/DO35HpHhPFESWfNtQYWXCIOr-m.jpg"
  },
  {
    "id": 32,
    "albumid": 5,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/tJhJSNoxATk7V2ASBh8qrp6p-m.jpg"
  },
  {
    "id": 33,
    "albumid": 5,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/SRXu4rzGcQjVXrFCpTPtfSvk-m.jpg"
  },
  {
    "id": 34,
    "albumid": 5,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/W9Q1LCO4NLpOlRlNmtoQmuQQ-m.jpg"
  },
  {
    "id": 35,
    "albumid": 5,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/9i6nOIIHgyktcczuoL5MCOdn-m.jpg"
  },
  {
    "id": 36,
    "albumid": 6,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/version04-02.jpg"
  },
  {
    "id": 37,
    "albumid": 6,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/version04-03.jpg"
  },
  {
    "id": 38,
    "albumid": 6,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/version04-04.jpg"
  },
  {
    "id": 39,
    "albumid": 6,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/version04-05.jpg"
  },
  {
    "id": 40,
    "albumid": 6,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/version04-06.jpg"
  },
  {
    "id": 41,
    "albumid": 6,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/version04-07.jpg"
  },
  {
    "id": 42,
    "albumid": 6,
    "image": "https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/version04-08.jpg"
  },
  {
    "id": 43,
    "albumid": 7,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-answer/photo04-02-m.jpg"
  },
  {
    "id": 44,
    "albumid": 7,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-answer/photo04-03-m.jpg"
  },
  {
    "id": 45,
    "albumid": 7,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-answer/photo04-04-m.jpg"
  },
  {
    "id": 46,
    "albumid": 7,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-answer/photo04-05-m.jpg"
  },
  {
    "id": 47,
    "albumid": 7,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-answer/photo04-06-m.jpg"
  },
  {
    "id": 48,
    "albumid": 7,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-answer/photo04-07-m.jpg"
  },
  {
    "id": 49,
    "albumid": 7,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-answer/photo04-08-m.jpg"
  },
  {
    "id": 50,
    "albumid": 8,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-tear/photo04-02-m.jpg"
  },
  {
    "id": 51,
    "albumid": 8,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-tear/photo04-03-m.jpg"
  },
  {
    "id": 52,
    "albumid": 8,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-tear/photo04-04-m.jpg"
  },
  {
    "id": 53,
    "albumid": 8,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-tear/photo04-05-m.jpg"
  },
  {
    "id": 54,
    "albumid": 8,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-tear/photo04-06-m.jpg"
  },
  {
    "id": 55,
    "albumid": 8,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-tear/photo04-07-m.jpg"
  },
  {
    "id": 56,
    "albumid": 8,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-tear/photo04-08-m.jpg"
  },
  {
    "id": 57,
    "albumid": 9,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-her/photo04-02-m.jpg"
  },
  {
    "id": 58,
    "albumid": 9,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-her/photo04-03-m.jpg"
  },
  {
    "id": 59,
    "albumid": 9,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-her/photo04-04-m.jpg"
  },
  {
    "id": 60,
    "albumid": 9,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-her/photo04-05-m.jpg"
  },
  {
    "id": 61,
    "albumid": 9,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-her/photo04-06-m.jpg"
  },
  {
    "id": 62,
    "albumid": 9,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-her/photo04-07-m.jpg"
  },
  {
    "id": 63,
    "albumid": 9,
    "image": "https://ibighit.com/bts/images/bts/discography/love_yourself-her/photo04-08-m.jpg"
  },
  {
    "id": 64,
    "albumid": 10,
    "image": "https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/photo-02-m.jpg"
  },
  {
    "id": 65,
    "albumid": 10,
    "image": "https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/photo-03-m.jpg"
  },
  {
    "id": 66,
    "albumid": 10,
    "image": "https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/photo-04-m.jpg"
  },
  {
    "id": 67,
    "albumid": 10,
    "image": "https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/photo-05-m.jpg"
  },
  {
    "id": 68,
    "albumid": 10,
    "image": "https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/photo-06-m.jpg"
  },
  {
    "id": 69,
    "albumid": 10,
    "image": "https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/photo-07-m.jpg"
  },
  {
    "id": 70,
    "albumid": 10,
    "image": "https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/photo-08-m.jpg"
  },
  {
    "id": 71,
    "albumid": 11,
    "image": "https://ibighit.com/bts/images/bts/discography/wings/photo-05-m.jpg"
  },
  {
    "id": 72,
    "albumid": 11,
    "image": "https://ibighit.com/bts/images/bts/discography/wings/photo-08-m.jpg"
  },
  {
    "id": 73,
    "albumid": 11,
    "image": "https://ibighit.com/bts/images/bts/discography/wings/photo-12-m.jpg"
  },
  {
    "id": 74,
    "albumid": 11,
    "image": "https://ibighit.com/bts/images/bts/discography/wings/photo-13-m.jpg"
  },
  {
    "id": 75,
    "albumid": 11,
    "image": "https://ibighit.com/bts/images/bts/discography/wings/photo-17-m.jpg"
  },
  {
    "id": 76,
    "albumid": 11,
    "image": "https://ibighit.com/bts/images/bts/discography/wings/photo-20-m.jpg"
  },
  {
    "id": 77,
    "albumid": 11,
    "image": "https://ibighit.com/bts/images/bts/discography/wings/photo-21-m.jpg"
  },
  {
    "id": 78,
    "albumid": 12,
    "image": "https://ibighit.com/bts/images/bts/discography/young_forever/day-04-m.jpg"
  },
  {
    "id": 79,
    "albumid": 12,
    "image": "https://ibighit.com/bts/images/bts/discography/young_forever/day-05-m.jpg"
  },
  {
    "id": 80,
    "albumid": 12,
    "image": "https://ibighit.com/bts/images/bts/discography/young_forever/day-08-m.jpg"
  },
  {
    "id": 81,
    "albumid": 12,
    "image": "https://ibighit.com/bts/images/bts/discography/young_forever/day-10-m.jpg"
  },
  {
    "id": 82,
    "albumid": 12,
    "image": "https://ibighit.com/bts/images/bts/discography/young_forever/day-12-m.jpg"
  },
  {
    "id": 83,
    "albumid": 12,
    "image": "https://ibighit.com/bts/images/bts/discography/young_forever/day-14-m.jpg"
  },
  {
    "id": 84,
    "albumid": 12,
    "image": "https://ibighit.com/bts/images/bts/discography/young_forever/day-16-m.jpg"
  },
  {
    "id": 85,
    "albumid": 13,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/photo01-02-m.jpg"
  },
  {
    "id": 86,
    "albumid": 13,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/photo01-05-m.jpg"
  },
  {
    "id": 87,
    "albumid": 13,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/photo01-06-m.jpg"
  },
  {
    "id": 88,
    "albumid": 13,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/photo01-09-m.jpg"
  },
  {
    "id": 89,
    "albumid": 13,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/photo01-11-m.jpg"
  },
  {
    "id": 90,
    "albumid": 13,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/photo01-12-m.jpg"
  },
  {
    "id": 91,
    "albumid": 13,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/photo01-14-m.jpg"
  },
  {
    "id": 92,
    "albumid": 14,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/concept01-02-m.jpg"
  },
  {
    "id": 93,
    "albumid": 14,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/concept01-03-m.jpg"
  },
  {
    "id": 94,
    "albumid": 14,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/concept01-04-m.jpg"
  },
  {
    "id": 95,
    "albumid": 14,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/concept01-07-m.jpg"
  },
  {
    "id": 96,
    "albumid": 14,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/concept01-06-m.jpg"
  },
  {
    "id": 97,
    "albumid": 14,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/concept01-08-m.jpg"
  },
  {
    "id": 98,
    "albumid": 14,
    "image": "https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/concept01-09-m.jpg"
  },
  {
    "id": 99,
    "albumid": 15,
    "image": "https://ibighit.com/bts/images/bts/discography/dark_and_wild/version07-01-m.jpg"
  },
  {
    "id": 100,
    "albumid": 15,
    "image": "https://ibighit.com/bts/images/bts/discography/dark_and_wild/version03-01-m.jpg"
  },
  {
    "id": 101,
    "albumid": 15,
    "image": "https://ibighit.com/bts/images/bts/discography/dark_and_wild/version06-01-m.jpg"
  },
  {
    "id": 102,
    "albumid": 15,
    "image": "https://ibighit.com/bts/images/bts/discography/dark_and_wild/version08-01-m.jpg"
  },
  {
    "id": 103,
    "albumid": 15,
    "image": "https://ibighit.com/bts/images/bts/discography/dark_and_wild/version04-01-m.jpg"
  },
  {
    "id": 104,
    "albumid": 15,
    "image": "https://ibighit.com/bts/images/bts/discography/dark_and_wild/version05-01-m.jpg"
  },
  {
    "id": 105,
    "albumid": 15,
    "image": "https://ibighit.com/bts/images/bts/discography/dark_and_wild/version02-01-m.jpg"
  },
  {
    "id": 106,
    "albumid": 16,
    "image": "https://ibighit.com/bts/images/bts/discography/skool_luv_affair/concept02-01-m.jpg"
  },
  {
    "id": 107,
    "albumid": 16,
    "image": "https://ibighit.com/bts/images/bts/discography/skool_luv_affair/concept04-01-m.jpg"
  },
  {
    "id": 108,
    "albumid": 16,
    "image": "https://ibighit.com/bts/images/bts/discography/skool_luv_affair/concept03-01-m.jpg"
  },
  {
    "id": 109,
    "albumid": 16,
    "image": "https://ibighit.com/bts/images/bts/discography/skool_luv_affair/concept05-01-m.jpg"
  },
  {
    "id": 110,
    "albumid": 16,
    "image": "https://ibighit.com/bts/images/bts/discography/skool_luv_affair/concept06-01-m.jpg"
  },
  {
    "id": 111,
    "albumid": 16,
    "image": "https://ibighit.com/bts/images/bts/discography/skool_luv_affair/concept07-01-m.jpg"
  },
  {
    "id": 112,
    "albumid": 16,
    "image": "https://ibighit.com/bts/images/bts/discography/skool_luv_affair/concept08-01-m.jpg"
  },
  {
    "id": 113,
    "albumid": 17,
    "image": "https://ibighit.com/bts/images/bts/discography/o_rul8_2/rapmonster1-m.jpg"
  },
  {
    "id": 114,
    "albumid": 17,
    "image": "https://ibighit.com/bts/images/bts/discography/o_rul8_2/jin1-m.jpg"
  },
  {
    "id": 115,
    "albumid": 17,
    "image": "https://ibighit.com/bts/images/bts/discography/o_rul8_2/suga2-m.jpg"
  },
  {
    "id": 116,
    "albumid": 17,
    "image": "https://ibighit.com/bts/images/bts/discography/o_rul8_2/jhope1-m.jpg"
  },
  {
    "id": 117,
    "albumid": 17,
    "image": "https://ibighit.com/bts/images/bts/discography/o_rul8_2/jimin1-m.jpg"
  },
  {
    "id": 118,
    "albumid": 17,
    "image": "https://ibighit.com/bts/images/bts/discography/o_rul8_2/v2-m.jpg"
  },
  {
    "id": 119,
    "albumid": 17,
    "image": "https://ibighit.com/bts/images/bts/discography/o_rul8_2/jungkook2-m.jpg"
  },
  {
    "id": 120,
    "albumid": 18,
    "image": "https://ibighit.com/bts/images/bts/discography/2_cool_4_school/concept02-01-m.jpg"
  },
  {
    "id": 121,
    "albumid": 18,
    "image": "https://ibighit.com/bts/images/bts/discography/2_cool_4_school/concept05-01-m.jpg"
  },
  {
    "id": 122,
    "albumid": 18,
    "image": "https://ibighit.com/bts/images/bts/discography/2_cool_4_school/concept04-01-m.jpg"
  },
  {
    "id": 123,
    "albumid": 18,
    "image": "https://ibighit.com/bts/images/bts/discography/2_cool_4_school/concept07-01-m.jpg"
  },
  {
    "id": 124,
    "albumid": 18,
    "image": "https://ibighit.com/bts/images/bts/discography/2_cool_4_school/concept06-01-m.jpg"
  },
  {
    "id": 125,
    "albumid": 18,
    "image": "https://ibighit.com/bts/images/bts/discography/2_cool_4_school/concept03-01-m.jpg"
  },
  {
    "id": 126,
    "albumid": 18,
    "image": "https://ibighit.com/bts/images/bts/discography/2_cool_4_school/concept01-01-m.jpg"
  },
  {
    "id": 127,
    "albumid": 0,
    "image": "https://ibighit.com/bts/images/bts/discography/proof/photo/proof/3f0a1a5653f6d286ff227fc65c5bded9.jpg"
  },
  {
    "id": 128,
    "albumid": 0,
    "image": "https://ibighit.com/bts/images/bts/discography/proof/photo/proof/0e6999d2613d0e76268dbecd561a9a26.jpg"
  },
  {
    "id": 129,
    "albumid": 0,
    "image": "https://ibighit.com/bts/images/bts/discography/proof/photo/proof/f2d81e1fab04398a144dcf3727e14951.jpg"
  },
  {
    "id": 130,
    "albumid": 0,
    "image": "https://ibighit.com/bts/images/bts/discography/proof/photo/proof/64182aac144759c54c1778f5c0ca454a.jpg"
  },
  {
    "id": 131,
    "albumid": 0,
    "image": "https://ibighit.com/bts/images/bts/discography/proof/photo/proof/e40624478271061520d0b071cc1c51e1.jpg"
  },
  {
    "id": 132,
    "albumid": 0,
    "image": "https://ibighit.com/bts/images/bts/discography/proof/photo/proof/e2d747b8f8ec988e1dbaa2cff16991c2.jpg"
  },
  {
    "id": 133,
    "albumid": 0,
    "image": "https://ibighit.com/bts/images/bts/discography/proof/photo/proof/5a3809dc731570c076da51db716b6a6e.jpg"
  }
]